module.exports = __webpack_public_path__ + "img/aneuflow.c110771d.png";